import { type RefObject, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import { Head } from 'widgets/CallPopUp/ui/components/Head/Head'
import { CallBaseContent } from '../CallBaseContent/CallBaseContent'
import styles from './../../styles.module.scss'

type ICallPopUpContentProps = {
  refWrap: RefObject<HTMLDivElement>
}

export const CallPopUpContent: FC<ICallPopUpContentProps> = observer(({ refWrap }) => {
  const { callStore, numbersStore } = useEntitiesContext()
  const store = useCallPopUpDefaultContext()

  if (!store.showPopUp) return null
  if (!store.isParticipants) return null
  if (!store.contactFrom) return null

  const number = numbersStore.getItem(callStore.numberId)

  return (
    <div className={styles.section}>
      <div ref={refWrap} className={styles.tooltipWrap} />

      <Head
        isIncoming={callStore.isIncoming}
        wrapElement={store.innerRefTooltipCurrent}
        name={store.contactFrom?.name}
        phone={number?.formatted_number}
        onClick={store.handleGoToConversation}
      />
      <CallBaseContent />
    </div>
  )
})
